import * as React from 'react';
import { FC } from 'react';
import {
    Create,
    EditProps,
} from 'react-admin';
import MerchantCommonEdit from './TransactionCommonEdit';
import {
    makeStyles,
    createStyles,
    Theme,
    CardContent,
    Card,
    CardActions,
    Button,
} from '@material-ui/core';
import { useHistory } from 'react-router';
import { ArrowBack } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        card: {
            width: '100%'
        },
    })
)

const CreateLayout = (props: any) => {
    const classes = useStyles()
    const history = useHistory()

    return <Card className={classes.root}>
        <CardActions>
            <Button
                variant="text"
                color="primary"
                startIcon={<ArrowBack />}
                onClick={() => history.goBack()}
            >Atrás
            </Button>
        </CardActions>
        <CardContent>
            <MerchantCommonEdit {...props} />
        </CardContent>
    </Card>
}

const MerchantEdit: FC<EditProps> = props => {

    return (
        <Create
            {...props}
        >
            <CreateLayout />
        </Create >
    )
}
export default MerchantEdit;
